import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import { Link } from "react-router-dom";
import CommunitySocialNav from "../Community/CommunitySocialNav";
import {
  communityPagesFromPayload,
  fetchCommunityNavigation,
} from "../Community/communityNavigationApi";
import "../Community/CommunityPlaceholderPage.css";
import "../Community/CommunitySocial.css";
import "./Games.css";

/**
 * Community page frame for Games: Community hero, Community sections subnav,
 * and the Social grid with the Community left rail (Games active).
 */
function CommunityGamesShell({ title, lede, documentTitle, children }) {
  const [sections, setSections] = useState([]);

  useEffect(() => {
    let cancelled = false;
    fetchCommunityNavigation()
      .then((payload) => {
        if (!cancelled) setSections(communityPagesFromPayload(payload));
      })
      .catch(() => {
        if (!cancelled) setSections([]);
      });
    return () => {
      cancelled = true;
    };
  }, []);

  return (
    <div className="community-page community-page--social community-page--games">
      <Helmet>
        <title>{documentTitle || "Games — Community"}</title>
      </Helmet>

      <header className="community-page__hero" aria-labelledby="community-games-title">
        <div className="community-page__shell">
          <p className="community-page__eyebrow">Community</p>
          <h1 id="community-games-title" className="community-page__title">
            {title}
          </h1>
          {lede ? <p className="community-page__lede">{lede}</p> : null}
        </div>
      </header>

      {sections.length > 1 ? (
        <nav className="community-page__subnav" aria-label="Community sections">
          <div className="community-page__shell community-page__subnav-inner">
            {sections.map((item) => {
              const itemSlug = item.slug || "";
              const path = item.path || `/community/${itemSlug}`;
              return (
                <Link
                  key={itemSlug || path}
                  to={path}
                  className="community-page__subnav-link"
                >
                  {item.name || item.title || itemSlug}
                </Link>
              );
            })}
          </div>
        </nav>
      ) : null}

      <main className="community-page__main">
        <div className="community-page__shell">
          <div className="community-social">
            <div className="community-social__grid">
              <aside className="community-social__col community-social__col--nav">
                <CommunitySocialNav activeKey="games" />
              </aside>
              <div className="community-social__col community-social__col--main">
                {children}
              </div>
            </div>
          </div>
        </div>
      </main>
    </div>
  );
}

export default CommunityGamesShell;
